import { useEffect, useState } from 'react';

export function useGlobalsConfig() {
  const [isLoading, setIsLoading] = useState(true);
  const [globalsConfig, setGlobalsConfig] = useState(null);
  async function getGlobalsConfigJson() {
    try {
      const url = `${import.meta.env.VITE_PUBLIC_URL}/globalsConfig.json?b=${window.CACHE_BUSTER}`;
      const resp = await fetch(url, {
        cache: 'no-cache',
        headers: {
          Accept: 'application/json',
        },
      });
      if (resp.ok) {
        const globalsJson = await resp.json();
        setGlobalsConfig(globalsJson);
      } else {
        throw new Error('globalsConfig.json fetch response was not OK.');
      }
      setIsLoading(false);
    } catch (e) {
      throw new Error('globalsConfig.json failed to fetch and return valid JSON.');
    }
  }
  useEffect(() => { getGlobalsConfigJson(); }, []);
  return {
    isLoading,
    globalsConfig,
  };
}
